(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("jWc9o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $77aba63f6370cd67$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $77aba63f6370cd67$var$FormServerError = ({ formState: formState })=>{
    const { errors: errors } = formState;
    if (errors?.["serverError"]) return /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
        className: "text-red500",
        children: errors["serverError"].message?.toString()
    });
    return null;
};
var $77aba63f6370cd67$export$2e2bcd8739ae039 = $77aba63f6370cd67$var$FormServerError;

});

})();
//# sourceMappingURL=FormServerError.4f00cd71.js.map
